export const CRM_VISIBILITY_PERMISSION = 'crm-visibility';

export const getPermissionModule = (permissionKey, permissions) => {
  return permissions?.find((permission) => {
    if (permission?.key === permissionKey) return true;
    return permission?.submodules?.includes(permissionKey);
  });
};

export const hasPermissionByKey = (permissionKey, permissions) => {
  return Boolean(getPermissionModule(permissionKey, permissions));
};

/** Dual gate: Salesforce CRM access + subscription CRM visibility. */
export const canShowCrmNav = (crmAccessEnabled, permissions) =>
  crmAccessEnabled === true && hasPermissionByKey(CRM_VISIBILITY_PERMISSION, permissions);
